var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenGateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6H12C12.55 6 13 6.45 13 7V13C13 13.55 12.55 14 12 14H4C3.45 14 3 13.55 3 13V7C3 6.45 3.45 6 4 6H5V3C5 1.89688 4.10313 1 3 1C1.89688 1 1 1.89688 1 3V7H0V3C0 1.34375 1.34375 0 3 0C4.65625 0 6 1.34375 6 3V6ZM7 10C7 10.5531 7.44688 11 8 11C8.55313 11 9 10.5531 9 10C9 9.44687 8.55313 9 8 9C7.44688 9 7 9.44687 7 10Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenGateIcon);
export default __webpack_public_path__ + "static/media/OpenGateIcon.f04cadf629abaef5790c7c51a2a4c3be.svg";
export { ForwardRef as ReactComponent };